import uploadError from '../actions/uploadError.js'

export default [uploadError]



// WEBPACK FOOTER //
// ./src/modules/user/chains/uploadError.js